'use strict';
const RestUtils = require('utils/RestUtils'),
    apiAppUrl = process.env.URL_API,
    Constants = require('constants/AppConstants'),
    Security = require('./Security').auth;

const HistoryServiceImpl = {

    getHistories(onSuccess) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)(JSON.parse(this.responseText));
            });
        });
        ajax.open('GET', apiAppUrl + '/histories', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    saveChanges(historyChanges, onSuccess) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this);
            });
        });
        ajax.open('POST', apiAppUrl + '/histories', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(historyChanges));
    }

};


module.exports = HistoryServiceImpl;



/** WEBPACK FOOTER **
 ** ./src/services/HistoryServiceImpl.js
 **/